module.exports = __webpack_public_path__ + "static/media/login-bg.231e3688.jpg";